import { Reveal } from "./Reveal";
import { useSite } from "../context/SiteContext";

const catColor = {
  Major: "text-gold border-gold/40",
  Minor: "text-forest-500 border-forest/30",
  Skill: "text-forest border-forest/30",
  "Value-Added": "text-muted border-line",
};

export default function SubjectsSection() {
  const { subjects } = useSite();
  if (!subjects || subjects.length === 0) return null;

  return (
    <section data-testid="subjects-section" className="bg-forest text-bone py-24 md:py-40 relative overflow-hidden grain">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 relative z-10">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-gold mb-4">Curriculum</p>
          <h2 className="font-serif text-4xl md:text-6xl tracking-tight leading-none">Subjects on Offer</h2>
          <p className="text-bone/50 mt-5 max-w-xl">
            Subjects students can opt for under the FYUP framework — maintained by the college administration.
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-bone/10 border border-bone/10">
          {subjects.map((s, i) => (
            <Reveal key={s.id || i} delay={(i % 3) * 0.05}>
              <div data-testid="subject-item" className="bg-forest p-8 h-full hover:bg-forest-900 transition-colors duration-300">
                <div className="flex items-start justify-between gap-3">
                  <h3 className="font-serif text-2xl text-bone">{s.name}</h3>
                  {s.category && (
                    <span className={`text-[10px] uppercase tracking-widest border px-2 py-0.5 rounded-full shrink-0 ${catColor[s.category] || "text-gold border-gold/40"}`}>
                      {s.category}
                    </span>
                  )}
                </div>
                {s.desc && <p className="text-bone/50 text-sm mt-3 leading-relaxed">{s.desc}</p>}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
